<div class="container" *ngIf="combinedWords.length > 0">
  <h4>คำค้นหาที่เกี่ยวข้อง:</h4>
  <ul class="horizontal-list">
    <li *ngFor="let word of combinedWords">
      <span class="highlight">{{ word }}</span>
    </li>
  </ul>
</div>